/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
window.mobileCheck = function() {
	let check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
};

( function() {
	const siteNavigation = document.getElementById( 'site-navigation' );

	// Return early if the navigation doesn't exist.
	if ( ! siteNavigation ) {
		return;
	}

	const button = siteNavigation.querySelector("button.menu-toggle");

	// Return early if the button doesn't exist.
	if ( 'undefined' === typeof button ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

	if ( ! menu.classList.contains( 'nav-menu' ) ) {
		menu.classList.add( 'nav-menu' );
	}

	if (window.mobileCheck() === true) {
		// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
		button?.addEventListener('click', function () {
			document.querySelector("body").classList.toggle('toggled');

			if (button.getAttribute('aria-expanded') === 'true') {
				button.setAttribute('aria-expanded', 'false');
			} else {
				button.setAttribute('aria-expanded', 'true');
			}
		});

		// // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
		// document.addEventListener('click', function (event) {
		// 	const isClickInside = siteNavigation.contains(event.target);
		//
		// 	if (!isClickInside) {
		// 		document.querySelector("body").classList.toggle('toggled');
		// 		button.setAttribute('aria-expanded', 'false');
		// 	}
		// });
	}

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName( '.menu-item-has-children > a' );

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

	// Toggle focus each time a menu link is focused or blurred.
	for ( const link of links ) {
		link.addEventListener( 'focus', toggleFocus, true );
		link.addEventListener( 'blur', toggleFocus, true );
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for ( const link of linksWithChildren ) {
		link.addEventListener( 'touchstart', toggleFocus, false );
	}



	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		if ( event.type === 'focus' || event.type === 'blur' ) {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while ( ! self.classList.contains( 'nav-menu' ) ) {
				// On li elements toggle the class .focus.
				if ( 'li' === self.tagName.toLowerCase() ) {
					self.classList.toggle( 'focus' );
				}
				self = self.parentNode;
			}
		}

		if ( event.type === 'touchstart' ) {
			const menuItem = this.parentNode;
			event.preventDefault();
			for ( const link of menuItem.parentNode.children ) {
				if ( menuItem !== link ) {
					link.classList.remove( 'focus' );
				}
			}
			menuItem.classList.toggle( 'focus' );
		}
	}
}() );

const header = document.querySelector('.site-header');
if (header) {
	const scrollThreshold = 50;
	window.addEventListener('scroll', () => {
		if (window.scrollY >= scrollThreshold) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	});
	window.addEventListener('DOMContentLoaded', () => {
		if (window.scrollY >= scrollThreshold) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	});


	document.addEventListener('DOMContentLoaded', () => {
		const topLevelMenus = document.querySelectorAll('.menu > li');

		let timeout; // Variable to store timeout ID

		topLevelMenus.forEach((menuItem, index) => {
			const submenuId = `submenu-${index}`; // Unique identifier for submenu
			const subMenu = menuItem.querySelector('.sub-menu');

			// Check if there's a sub-menu
			if (subMenu) {
				const firstLevelSubMenu = subMenu.cloneNode(true);
				const parentUl = menuItem.parentNode;

				firstLevelSubMenu.classList.remove('sub-menu');
				firstLevelSubMenu.classList.add('first-level', 'sub-menu');
				firstLevelSubMenu.setAttribute('id', submenuId); // Set unique id for submenu

				// Remove the original sub-menu from the parent <li>
				menuItem.removeChild(subMenu);

				// Append the first-level sub-menu to the parent <ul>
				parentUl.appendChild(firstLevelSubMenu);

				const secondLevelSubMenu = firstLevelSubMenu.querySelector('.sub-menu');
				if (secondLevelSubMenu) {
					secondLevelSubMenu.classList.remove('sub-menu');
					secondLevelSubMenu.classList.add('second-level', 'sub-menu');
				}
			}

			if (window.mobileCheck() === false) {
				menuItem.addEventListener('mouseover', () => {
					// Clear existing timeout
					clearTimeout(timeout);

					// Show the corresponding submenu when main menu item is hovered
					const correspondingSubMenu = document.getElementById(submenuId);
					if (correspondingSubMenu) {
						correspondingSubMenu.classList.add("submenu-visible");
					}
				});

				menuItem.addEventListener('mouseout', () => {
					// Set timeout to hide the submenu after a delay
					timeout = setTimeout(() => {
						const correspondingSubMenu = document.getElementById(submenuId);
						if (correspondingSubMenu) {
							correspondingSubMenu.classList.remove("submenu-visible");
						}
					}, 100); // Adjust delay time as needed
				});
			} else { // mobile = click
				menuItem.addEventListener('click', (e) => {
					if (menuItem.classList.contains("menu-item-has-children")) {
						e.preventDefault();
					}
					const correspondingSubMenu = document.getElementById(submenuId);
					if (correspondingSubMenu) {
						correspondingSubMenu.classList.toggle("submenu-visible");

						// Get the title of the parent menu item
						const parentMenuItemTitle = menuItem.querySelector('a').innerText;

						// Create an element to display the parent title
						const parentTitleElement = document.createElement('div');
						parentTitleElement.classList.add('h4', 'parent-title');
						parentTitleElement.textContent = parentMenuItemTitle;

						// Remove existing parent title elements
						correspondingSubMenu.querySelectorAll('.parent-title').forEach(element => {
							element.remove();
						});

						// Prepend the parent title element to the submenu
						correspondingSubMenu.insertBefore(parentTitleElement, correspondingSubMenu.firstChild);
					}

					// Create a back button element
					const backButton = document.createElement('a');
					backButton.classList.add('back-button');
					backButton.textContent = 'Terug';

					// Event listener for the back button
					backButton.addEventListener('click', () => {
						// Hide the current submenu
						correspondingSubMenu.classList.remove('submenu-visible');
					});

					// Remove existing parent title elements
					correspondingSubMenu.querySelectorAll('.back-button').forEach(element => {
						element.remove();
					});

					// Insert the back button before the parent title element
					correspondingSubMenu.insertBefore(backButton, correspondingSubMenu.firstChild);
				});
			}

			// Add mouseover and mouseout event listeners to submenu
			const correspondingSubMenu = document.getElementById(submenuId);
			if (correspondingSubMenu) {
				correspondingSubMenu.addEventListener('mouseover', () => {
					clearTimeout(timeout); // Clear timeout when mouse enters submenu
				});

				correspondingSubMenu.addEventListener('mouseout', () => {
					// Set timeout to hide the submenu after a delay
					timeout = setTimeout(() => {
						correspondingSubMenu.classList.remove("submenu-visible");
					}, 100); // Adjust delay time as needed
				});
			}
		});

		// Wrap all subitems inside a 'submenu-inner' div for each submenu
		const allSubMenus = document.querySelectorAll('.sub-menu, .subsub-menu');
		allSubMenus.forEach(subMenu => {
			const submenuInner = document.createElement('div');
			submenuInner.classList.add('submenu-inner');
			subMenu.childNodes.forEach(node => {
				if (node.nodeType === 1) { // Check if it's an element node
					submenuInner.appendChild(node.cloneNode(true));
				}
			});
			subMenu.innerHTML = ''; // Clear out existing subitems
			subMenu.appendChild(submenuInner);
		});
	});
}

const footer = document.querySelector('.site-footer');
if (footer) {
	const footerMiddle = footer.querySelector('#footerMiddle');
	Array.from(footerMiddle.querySelectorAll('div.toggle')).forEach(toggle => {
		toggle.addEventListener('click', () => {
			toggle.classList.toggle('active');
		});
	});
}